import axios from "axios";

axios.defaults.withCredentials = true;

const readAxiosInstance = axios.create({
  //baseURL: "http://localhost:12002/api/",
  //baseURL: "https://db.stride.pesa.solutions/api/",//in use
  baseURL: "https://pixi.db.pitch90agent.com/api/",
});

const writeAxiosInstance = axios.create({
  //baseURL: "http://localhost:12002/api/",
  //baseURL: "https://db.stride.pesa.solutions/api/",// prod in use
  baseURL: "https://pixi.db.pitch90agent.com/api/",
});

const axiosInstances = {
  read: readAxiosInstance,
  write: writeAxiosInstance,
};

export default axiosInstances;
